import spacing from 'theme/config/spacing'

const style = {
  container: {
    padding: spacing(1)
  },
}

export default style
